import React from 'react';
import { Card, Badge, Row, Col } from 'react-bootstrap';
import { FaBirthdayCake, FaMedal, FaClock, FaBell } from 'react-icons/fa';
import './ReminderList.css';

const ReminderList = ({ reminders, loading }) => {
    const getDaysUntilText = (daysUntil) => {
        if (daysUntil === 0) return 'Today';
        if (daysUntil === 1) return 'Tomorrow';
        return `In ${daysUntil} days`;
    };

    const getPriorityClass = (daysUntil) => {
        if (daysUntil === 0) return 'priority-today';
        if (daysUntil === 1) return 'priority-tomorrow';
        if (daysUntil <= 2) return 'priority-high';
        return 'priority-normal';
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (reminders.length === 0) {
        return (
            <Card className="shadow-sm border-0 text-center py-5">
                <Card.Body>
                    <div className="empty-state">
                        <FaBell className="empty-icon mb-3" />
                        <h4>No Upcoming Reminders</h4>
                        <p className="text-muted">
                            There are no birthdays or work anniversaries in the selected period.
                        </p>
                    </div>
                </Card.Body>
            </Card>
        );
    }

    return (
        <div className="reminder-list">
            <Row className="g-3">
                {reminders.map((reminder, index) => (
                    <Col md={6} lg={4} key={index}>
                        <Card className={`reminder-card shadow-sm border-0 h-100 ${getPriorityClass(reminder.daysUntil)}`}>
                            <Card.Body>
                                <div className="reminder-card-header">
                                    <div className={`reminder-icon-wrapper ${reminder.type}`}>
                                        {reminder.type === 'birthday' ? (
                                            <FaBirthdayCake className="reminder-type-icon" />
                                        ) : (
                                            <FaMedal className="reminder-type-icon" />
                                        )}
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <h5 className="reminder-employee-name mb-1">
                                            {reminder.employeeName}
                                        </h5>
                                        {reminder.department && (
                                            <p className="reminder-department mb-0">
                                                {reminder.department}
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <div className="reminder-details mt-3">
                                    <div className="reminder-type-badge mb-2">
                                        <Badge bg={reminder.type === 'birthday' ? 'info' : 'warning'}>
                                            {reminder.type === 'birthday' ? 'Birthday' : 'Work Anniversary'}
                                        </Badge>
                                        {reminder.years && (
                                            <Badge bg="secondary" className="ms-2">
                                                {reminder.years} {reminder.years === 1 ? 'Year' : 'Years'}
                                            </Badge>
                                        )}
                                    </div>

                                    <div className="reminder-date-info">
                                        <FaClock className="me-2" />
                                        <span className="date-text">
                                            {new Date(reminder.date).toLocaleDateString('en-US', {
                                                month: 'long',
                                                day: 'numeric',
                                                year: 'numeric'
                                            })}
                                        </span>
                                    </div>

                                    <div className="reminder-countdown mt-2">
                                        <Badge
                                            bg={reminder.daysUntil <= 1 ? 'danger' : reminder.daysUntil <= 2 ? 'warning' : 'primary'}
                                            className="countdown-badge"
                                        >
                                            {getDaysUntilText(reminder.daysUntil)}
                                        </Badge>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default ReminderList;
